<ng-container>
	<ng-content></ng-content>
	<mat-icon class="select-arrow" svgIcon="select-arrow"></mat-icon>
	<label class="body3 length" *ngIf="input.hasMaxLength">{{length}}/{{input.maxlength}}</label>
</ng-container>
